export const vacancyStatus = Object.freeze({
  DRAFT: 'draft',
  ACTIVE: 'active',
  ARCHIVE: 'archive',
});

export const vacancyVisibility = Object.freeze({
  ALL: 'all',
  INVITATION: 'invitation',
});

export const candidateInvitationType = Object.freeze({
  ONLINE_INTERVIEW: 'virtual_interview',
  OFFICE_INTERVIEW: 'office_interview',
});

export const candidateLogType = Object.freeze({
  COMMENT: 'comment',
  INVITED: 'invited',
  SELF_INVITED: 'self_invited',
  INTERVIEWED: 'interviewed',
  INOFFICE_INTERVIEW: 'inoffice_interview',
  JOB_OFFER: 'job_offer',
  HIRED: 'hired',
  DECLINED: 'declined',
  REFUSED: 'refused',
  IMPORTED: 'imported',
  COVER_LETTER: 'cover_letter',
  OFFICE_INTERVIEW_PASSED: 'office_interview_passed',
  MESSAGE_SENT: 'message_sent',
  FOLLOWING_INVITE_LINK: 'following_invite_link',
  ONLINE_INTERVIEW_RECORDING_STARTED: 'online_interview_recording_started',
  ONLINE_INTERVIEW_PROCESSING_FAILED: 'online_interview_processing_failed',
  OFFICE_INTERVIEW_PROCESSING_FAILED: 'office_interview_processing_failed',
  STATUS_CHANGED: 'status_changed',
  AI_INTERVIEW_REVIEW_READY: 'ai_interview_review_ready',
  AI_PROCESSING_READY: 'ai_processing_ready',
  INTERVIEW_TRANSCRIPTION_READY: 'interview_transcription_ready',
  CANDIDATE_ADDITIONAL_FIELDS: 'candidate_additional_fields',
});

export const interviewStatuses = Object.freeze({
  BLANK: 'blank',
  RECORDING: 'recording',
  COMPLETE: 'complete',
  PROCESSING: 'processing',
  READY: 'ready',
  PROCESSING_FAILED: 'processing_failed',
});

export const interviewVideoTimestampTypes = Object.freeze({
  HELLO: 'hello',
  WELCOME: 'welcome',
  GOODBYE: 'goodbye',
  TEXT_QUESTION: 'text_question',
  RESUME: 'resume',
  LISTENING: 'listening',
});

export const candidateStatuses = Object.freeze({
  INVITED: 'invited',
  INTERVIEWED: 'interviewed',
  INOFFICE_INTERVIEW: 'inoffice_interview',
  JOB_OFFER: 'job_offer',
  HIRED: 'hired',
  DECLINED: 'declined',
  PASSED_DEMO_INTERVIEW: 'passed_demo_interview',
  IMPORTED: 'imported',
  TESTED: 'tested',
});

export const interviewType = Object.freeze({
  ONLINE_INTERVIEW: 'virtual_interview',
  OFFICE_INTERVIEW: 'office_interview',
});

export const localeType = Object.freeze({
  EN: 'en',
  RU: 'ru',
  UK: 'ru', // Ukrainian
  BE: 'ru', // Belarusian
  KK: 'ru', // Kazakh
  DEFAULT: 'en',
});

export const logType = Object.freeze({
  CANDIDATE: 'candidate',
  OFFICE_INTERVIEW: 'office_interview',
  ONLINE_INTERVIEW: 'online_interview',
});

export const zendeskFields = Object.freeze({
  USER_AGENT: 360011282959,
  BROWSER: 360010662720,
  OS: 360010666739,
  APP: 360010667199,
  MEDIA_DEVICES: 360010667219,
  CURRENT_PAGE: 360010663960,
  LOGROCKET_URL: 360011297240,
});

export const UTM_TAGS = [
  'utm_campaign',
  'utm_content',
  'utm_medium',
  'utm_source',
  'utm_term',
];

export const candidateInterviewType = Object.freeze({
  ONLINE_INTERVIEW: 'online_interview',
  OFFICE_INTERVIEW: 'office_interview',
  VIDEO_CALL: 'video_call',
  UPLOADED_VIDEO: 'uploaded_video',
});

export const testQuestionTypes = Object.freeze({
  SELECT: 'select',
  MULTISELECT: 'multiselect',
  TEXT: 'text',
  FREE: 'free',
  NUMERIC: 'numeric',
});

export const testTypes = Object.freeze({
  NOT_REQUIRED: 'not_required',
  EXPLANATION: 'explanation',
  CUTOFF: 'cutoff',
});

export const timestampTypes = Object.freeze({
  LISTENING: 'listening',
  ANSWERING: 'answering',
});
